export const horizontalSpace = '64px';
export const headerSize = '64px';
export const headerFormSize = '148px';
export const headerCollapsedSize = '40px';
